// extracted by mini-css-extract-plugin
export default {"customLinkRow":"custom_link___customLinkRow___f84d9c16"};